module.exports = __webpack_public_path__ + "img/04-dark.5a9b8f96.png";